module.exports = __webpack_public_path__ + "static/media/select-arrow.1e09f76f.svg";